module.exports = __webpack_public_path__ + "static/media/departures.71dd92aa.svg";